import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Global error handling setup

// Capture runtime errors
window.onerror = function (message, source, lineno, colno, error) {
    console.error("Error captured:", {
      message,
      source,
      lineno,
      colno,
      error,
    });
    return true; // Prevents the default browser error handler from running
  };

  window.addEventListener('error', (event) => {
    if (event.message === "The operation was aborted.") {
      console.error("Operation aborted error captured:", event);
      event.preventDefault(); // Prevent the default error handling
    }
  });
  
  
  // Capture resource loading errors and others
  window.addEventListener("error", (event) => {
    // Distinguish between different types of errors
    if (event.target instanceof HTMLElement) {
      console.error("Resource error captured:", {
        tagName: event.target.tagName,
        source: event.target.src || event.target.href,
      });
    } else {
      console.error("Error event captured:", event);
    }
    event.preventDefault(); // Prevents the default error handling
  }, true); // Use the capture phase to handle resource loading errors
  
  // Capture unhandled promise rejections
  window.addEventListener("unhandledrejection", (event) => {
    console.error("Unhandled promise rejection:", event.reason);
    event.preventDefault(); // Prevents the default handling of unhandled rejections
  });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);


